import React from "react";
import { UserDataContext } from "./UserDataContext.js";

export const useUserData = () => React.useContext(UserDataContext);

// For components that only ever render inside an authenticated route, where
// `Routes` has already gated on `currentUser`. Narrows the nullable context
// value instead of asserting it away, and fails loudly if that invariant is
// ever broken rather than throwing on a property access further down.
export const useAuthenticatedViewer = () => {
  const { currentUser } = useUserData();
  if (!currentUser) {
    throw new Error(
      "useAuthenticatedViewer used outside an authenticated route"
    );
  }
  return currentUser;
};
